<div
  id="filterDropdown"
  class="siteFilters__dropdown"
  (ppOnRendered)="onFilterDropdownRendered($event)"
>
  <pp-button-dropdown
    [ppSrc]="EIconPath.ICON_TABLE_FILTER"
    [ppText]="'filters' | ppTranslate"
    [ppNumber]="filterNumber"
    [ppActive]="filterNumber.length > 0 || isDropdownVisible"
    (ppAction)="toggleDropdown()"
    data-m-target="Filter dropdown button"
    id="filterDropdownBtn"
    [ppDisabled]="(customFields | keyvalue).length === 0 || !ppDataFetched"
    [ppHideTextOnMobile]="ppHideTextOnMobile"
  ></pp-button-dropdown>
  <pp-filter-dropdown
    [ppShow]="isDropdownVisible"
    ppAlign="left"
    [ppFullWidth]="true"
    [ppMinWidth]="minWidth"
  >
    @if (isDropdownVisible) {
      <header class="filterDropdown__header filterDropdown__header--with-border">
        <div class="filtersViewHeader">
          <h6 class="filterView__title">
            {{ 'filter_by' | ppTranslate }}
            <pp-icon
              ppTooltip
              [ppTitle]="'advanced_filter_tooltip' | ppTranslate"
              [ppSrc]="EIconPath.ICON_BADGE_INFO"
              ppColor="grey-600"
              ppClass="setSize14"
              [ppMobileTooltip]="true"
            />
          </h6>

          @if (shouldDisplaySaveToCurrentView) {
            <pp-saved-view-preview-header
              data-test="filtersSaveToViewHeader"
              [ppWorkspaceId]="workspaceId"
              (ppSaveToCurrentView)="saveFiltersToView()"
              [ppProcessing]="saveViewProcessing"
            />
          }
        </div>
      </header>
    }
    <div #filterDropdown class="popupFilters__container">
      @if (isDropdownVisible) {
        <pp-filter-container
          [ppWorkspaceId]="workspaceId"
          (ppFiltersChanged)="setQuickFilters($event)"
        />
      }
    </div>

    <footer class="filterDropdown__footer filterDropdown__footer--basicOnly">
      <div class="filterDropdown__buttons">
        <button
          id="filterDropdownCancelBtn"
          class="filterDropdown__cancel"
          data-test="clearFiltersButton"
          (click)="clearFilters()"
        >
          {{ 'clear_all' | ppTranslate }}
        </button>

        <pp-button
          ppStyle="primary"
          ppSize="large"
          ppId="filterDropdownApplyBtn"
          (ppAction)="handleApplyFilters()"
          [ppIsLoading]="isFiltersLoading"
        >
          {{ 'done' | ppTranslate }}
        </pp-button>
      </div>
    </footer>
  </pp-filter-dropdown>
</div>
